import { render, staticRenderFns } from "./verCobro.vue?vue&type=template&id=6cd2b6d2&scoped=true"
import script from "./verCobro.vue?vue&type=script&lang=js"
export * from "./verCobro.vue?vue&type=script&lang=js"
import style0 from "./verCobro.vue?vue&type=style&index=0&id=6cd2b6d2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2b6d2",
  null
  
)

export default component.exports